
import Vue from "vue";
import IconTextButton from "@/components/buttons/IconTextButton.vue";
import BaseButton from "@/components/buttons/BaseButton.vue";

export default Vue.extend({
  components: {
    IconTextButton,
    BaseButton
  },
  props: {
    hasNoEditRights: Boolean,
    heading: String,
  },
  data: () => ({
    isActive: false,
    isValid: false,
    deadline: "",
    isBusy: false
  }),
  computed: {
    rules() {
      return {
        required: (value: string) => !!value || this.$t("Rules.Required"),
      };
    },
  },
  methods: {
    show: function () {
      this.isActive = true;
    },
    hide: function () {
      this.isActive = false;
    },
    cancel: function () {
      this.hide();
      this.$emit("canceled");
    },
    confirm: function () {
      this.hide();
      this.$emit("confirmed", this.deadline);
    },
    validateDialogForm(){
      (this.$refs.dialogForm as any).validate()
    }
  }
});
